import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Org users eligible to be assigned an item-master change set — those with
 * full Product permissions (create + read + update + delete). Backs the
 * assignee picker.
 */
export function useProductAssignees() {
  return useQuery({
    ...orpc.core.users.listProductAssignees.queryOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
